import api from '../api/axios';

/*
 * Web push aboneliği — tarayıcı / ana ekrana eklenmiş uygulama.
 *
 * Mobil uygulamanın Expo push'undan AYRI kanal; ikisi birbirinin yerine
 * geçmiyor. Mobil öğretmen ve stajyerlerde, web push veli ve yöneticilerde.
 *
 * iOS KISITI (Apple'ın, bizim değil): bildirim yalnızca sayfa ANA EKRANA
 * EKLENDİYSE çalışıyor — Safari sekmesinde `Notification` bile tanımlı
 * olmayabiliyor. Android/masaüstü Chrome'da sekmede de çalışıyor.
 */

/** Tarayıcı bu işi yapabiliyor mu? */
export const pushDesteginiKontrolEt = () =>
  typeof window !== 'undefined' &&
  'serviceWorker' in navigator &&
  'PushManager' in window &&
  typeof Notification !== 'undefined';

/**
 * iOS'ta ana ekrana eklenmiş mi?
 *
 * Eklenmemişse iPhone'da abonelik denemesi sessizce başarısız olur ya da
 * hiç izin sorulmaz. Kullanıcıya "izin vermediniz" demek yanlış olurdu —
 * doğru mesaj "önce Ana Ekrana Ekleyin".
 */
export const iosAnaEkranaEklenmisMi = () =>
  window.navigator.standalone === true ||
  window.matchMedia('(display-mode: standalone)').matches;

export const iosMu = () =>
  /iphone|ipad|ipod/i.test(window.navigator.userAgent) ||
  // iPadOS 13+ kendini masaüstü Safari gibi tanıtıyor.
  (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);

// VAPID public key base64url olarak geliyor; PushManager Uint8Array istiyor.
const anahtariCevir = (base64) => {
  const padding = '='.repeat((4 - (base64.length % 4)) % 4);
  const duz = (base64 + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(duz);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const serviceWorkerKaydet = async () => {
  if (!pushDesteginiKontrolEt()) return null;
  try {
    return await navigator.serviceWorker.register('/sw.js');
  } catch {
    return null;
  }
};

/** Bu tarayıcıda zaten abone miyiz? */
export const mevcutAbonelik = async () => {
  if (!pushDesteginiKontrolEt()) return null;
  try {
    const reg = await navigator.serviceWorker.getRegistration();
    if (!reg) return null;
    return await reg.pushManager.getSubscription();
  } catch {
    return null;
  }
};

/**
 * Abone ol. İZNİ KULLANICI DOKUNUŞUNDAN İSTEMEK ZORUNDAYIZ — iOS, sayfa
 * açılışında otomatik istenen izni reddediyor. Bu yüzden yalnızca düğmeden
 * çağrılıyor, `useEffect` içinden değil.
 *
 * @returns {{ok: boolean, sebep?: string}}
 */
export const abonelikKur = async (vapidPublicKey) => {
  if (!pushDesteginiKontrolEt()) return { ok: false, sebep: 'desteklenmiyor' };
  if (!vapidPublicKey) return { ok: false, sebep: 'yapilandirilmamis' };
  if (iosMu() && !iosAnaEkranaEklenmisMi()) return { ok: false, sebep: 'ios_ana_ekran' };

  const izin = await Notification.requestPermission();
  if (izin !== 'granted') return { ok: false, sebep: 'izin_verilmedi' };

  const reg = (await navigator.serviceWorker.getRegistration()) || (await serviceWorkerKaydet());
  if (!reg) return { ok: false, sebep: 'sw_kaydedilemedi' };

  // `ready` beklenmezse ilk kayıttan hemen sonra subscribe çağrısı
  // "no active Service Worker" ile düşüyor.
  await navigator.serviceWorker.ready;

  try {
    const abonelik =
      (await reg.pushManager.getSubscription()) ||
      (await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: anahtariCevir(vapidPublicKey),
      }));

    const json = abonelik.toJSON();
    await api.post('/push-subscription', {
      endpoint: abonelik.endpoint,
      p256dh: json.keys.p256dh,
      auth: json.keys.auth,
    });

    return { ok: true };
  } catch {
    return { ok: false, sebep: 'abone_olunamadi' };
  }
};

/** Aboneliği kaldır — hem tarayıcıdan hem sunucudan. */
export const aboneliktenCik = async () => {
  const abonelik = await mevcutAbonelik();
  if (!abonelik) return;

  // ÖNCE sunucuya haber ver: tarayıcıdan sildikten sonra endpoint'e
  // erişemeyiz ve sunucuda ölü kayıt kalır (bir sonraki gönderimde
  // 410 alıp temizlenir ama o zamana kadar boşuna denenir).
  try {
    await api.delete('/push-subscription', { data: { endpoint: abonelik.endpoint } });
  } catch {
    // Sunucu ulaşılamazsa da tarayıcı tarafını temizle — kullanıcı
    // "kapat" dedi, kapanmış olmalı.
  }
  await abonelik.unsubscribe().catch(() => {});
};
